import { getGeneralImage } from "../../../Helpers/functions";
import { WidgetHeader } from "../widgets.types";

export default function WidgetTitle({ data }: { data: WidgetHeader }) {

  const { title, subTitle, icon } = data;

  return (
    <div className="d-flex align-items-start justify-content-between">
      <div>
        {title && (
          <div
            style={{
              color: title.style?.textColor,
            }}
            className={`${title.style?.bold ? "fw-bold" : ""} text-16`}
          >
            {data.title?.text ?? ""}
          </div>
        )}

        {subTitle && (
          <div
            style={{
              color: subTitle?.style?.textColor,
            }}
            className={`${subTitle.style?.bold ? "fw-bold" : ""} text-14`}
          >
            {subTitle?.text ?? ""}
          </div>
        )}
      </div>

      {icon && (
        <img
          src={getGeneralImage(icon.iconPath)}
          alt=""
          style={{ width: 22, height: 22 }}
          className="mx-4"
        />
      )}
    </div>
  );
}
